export default __webpack_public_path__ + "static/media/user-x.8424ce18.svg";